// ROM "embutida": o servidor entrega o jogo para quem tem acesso liberado.

export interface RemoteRom {
  sha1: string;
  size: number;
  /** Só nas nossas ROMs (decompilação): nome da versão, til na fonte e endereços. */
  label?: string;
  tilde?: boolean;
  /** A ROM entrega o inicial escolhido no cadastro (script nosso no quarto do jogador). */
  starter?: boolean;
  symbols?: Record<string, number>;
}

export type RemoteRomStatus =
  | { status: 'ok'; rom: RemoteRom }
  /** O servidor não tem ROM: cada um escolhe a sua. */
  | { status: 'none' }
  /** Conta do Telegram ainda não liberada por um admin. */
  | { status: 'forbidden' }
  /** Aberto fora do Telegram (ou initData velho). */
  | { status: 'unauthorized' }
  | { status: 'offline' };

export async function fetchRemoteRom(authorization: string): Promise<RemoteRomStatus> {
  let response: Response;
  try {
    response = await fetch('api/rom/info', { headers: { authorization }, cache: 'no-store' });
  } catch {
    return { status: 'offline' };
  }
  if (response.status === 404) return { status: 'none' };
  if (response.status === 403) return { status: 'forbidden' };
  if (response.status === 401) return { status: 'unauthorized' };
  if (!response.ok) return { status: 'offline' };
  try {
    return { status: 'ok', rom: (await response.json()) as RemoteRom };
  } catch {
    // Ex.: em produção sem o servidor do jogo, o /api cai no index.html.
    return { status: 'none' };
  }
}

/** Baixa a ROM (vem comprimida; o navegador descomprime) avisando o progresso de 0 a 1. */
export async function downloadRom(
  authorization: string,
  expectedSize: number,
  onProgress: (fraction: number) => void,
): Promise<Uint8Array> {
  const response = await fetch('api/rom', { headers: { authorization }, cache: 'no-store' });
  if (!response.ok || !response.body) throw new Error(`o servidor respondeu ${response.status}`);

  const data = new Uint8Array(expectedSize);
  const reader = response.body.getReader();
  let received = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    if (received + value.length > expectedSize) throw new Error('arquivo maior que o esperado');
    data.set(value, received);
    received += value.length;
    onProgress(received / expectedSize);
  }
  if (received !== expectedSize) throw new Error('download incompleto');
  return data;
}
